import { useQuery } from '@tanstack/react-query';
import { Tabla } from '@xiltrion/ui/bloques/tabla';
import { iconoArchivo } from '@xiltrion/ui/bloques/carga-archivos';
import { Badge } from '@xiltrion/ui/badge';
import { Icono } from '@xiltrion/ui/icono';
import { apiGet, downloadUrl } from '@/api/client';
import { usePersonas } from '@/api/hooks';
import type { Attachment } from '@/api/types';
import type { ViewProps } from '@/app/extension-points';

/** Archivos y evidencias del proyecto, con su huella SHA-256. */
export function FilesView({ project, onOpenTask }: ViewProps) {
  const { porId: people } = usePersonas();
  const { data = [], isLoading } = useQuery({ queryKey: ['project-files', project?.id], queryFn: () => apiGet<Attachment[]>(`/projects/${project!.id}/files`), enabled: !!project });
  return (
    <div className="p-4">
      <Tabla
        filas={data}
        claveFila={(a) => a.id}
        cargando={isLoading}
        vacio="Aún no hay archivos. Se adjuntan desde cada tarea."
        columnas={[
          { key: 'name', titulo: 'Archivo', valor: (a) => a.fileName, render: (a) => <a href={downloadUrl(`/attachments/${a.id}`)} className="inline-flex items-center gap-2 font-medium hover:underline" onClick={(e) => e.stopPropagation()}><Icono nombre={iconoArchivo({ type: a.mimeType, name: a.fileName })} />{a.fileName}</a>, secundario: (a) => `${(a.sizeBytes / 1024).toFixed(0)} KB · SHA-256 ${a.sha256.slice(0, 16)}…` },
          { key: 'evidence', titulo: 'Tipo', valor: (a) => (a.isEvidence ? 'Evidencia' : 'Adjunto'), render: (a) => (a.isEvidence ? <Badge variant="success-light">Evidencia</Badge> : <Badge variant="outline">Adjunto</Badge>), unaLinea: true },
          { key: 'task', titulo: 'Tarea', valor: (a) => a.taskTitle ?? '', render: (a) => (a.taskId ? <button type="button" className="text-left hover:underline" onClick={(e) => { e.stopPropagation(); onOpenTask(a.taskId!); }}>T-{a.taskNumber} {a.taskTitle}</button> : '—') },
          { key: 'by', titulo: 'Subió', valor: (a) => people.get(a.uploadedBy ?? '')?.nombre ?? '', unaLinea: true },
          { key: 'date', titulo: 'Fecha', valor: (a) => a.createdAt, render: (a) => new Date(a.createdAt).toLocaleDateString('es-CO'), unaLinea: true },
        ]}
      />
    </div>
  );
}
